import { ThemeProvider } from '@emotion/react';
import { useState, useEffect } from 'react';
import { MDXProvider } from '@mdx-js/react';
import { GlobalStyles, colors } from '../components/layout/GlobalStyles';
import { Nav } from '../components/layout/nav/Nav';
import { YellowPanel } from '../components/Yellow-Panel';
import { SlantedPicture } from '../components/SlantedPicture';
import { FAQ } from '../components/Faq';
import { Button } from '../components/layout/StyledComponents';
import { Hours } from '../components/layout/Hours';
import { AppointmentTwo } from '../components/layout/Appointment-two';
import { HomeTestimonials } from '../components/HomeTestimonials';
import { HomeVideo } from '../components/HomeVideo';

import { Vip } from '../components/layout/Vip';
import { Footer } from '../components/layout/Footer';

interface Props {
    home?: boolean;
    vip?: boolean;
}

export const DefaultLayout: React.FC<Props> = ({ children, home, vip }) => {
    const shortCodes = { FAQ, HomeVideo, HomeTestimonials, Button, SlantedPicture, YellowPanel };

    return (
        <div id="layout">
            <ThemeProvider theme={colors}>
                <GlobalStyles />
                <Nav />
                <MDXProvider components={shortCodes}>{children}</MDXProvider>
                <Hours />
                <AppointmentTwo />
                {!vip && <Vip />}
                <Footer />
            </ThemeProvider>
        </div>
    );
};
